<template>
  <div class="interaction-nav-bar">
    <div class="interaction-nav-bar__head">
      <h3 class="interaction-nav-bar__title">{{ $tInteraction('Status') }}</h3>
    </div>

    <div v-if="statuses"
         class="interaction-nav-bar__buttons-wrap custom-scrollbar" ref="nav-carousel">
      <ul class="interaction-nav-bar__buttons">
        <li v-for="(step, index) in stepsComputed"
            :key="index" class="interaction-nav-bar__buttons-item">
          <div class="interaction-nav-bar__btn"
               :class="getClass(step.key)"
          >
            <span class="interaction-nav-bar__btn-ico">
              <!--<span class="interaction-nav-bar__btn-label _done">
                <BaseSvg name="ico-check"/>
              </span>
              -->
              <span :class="statuses[step.key] === 'checked' ? '_show' : null"
                    class="interaction-nav-bar__btn-label _done">
                <BaseSvg name="ico-check"/>
              </span>
              <span :class="statuses[step.key] === 'pending' ? '_show' : null"
                    class="interaction-nav-bar__btn-label _wait">
                <BaseSvg name="ico-gear-2"/>
              </span>
              <BaseSvg :name="step.ico"/>
            </span>
            <span class="interaction-nav-bar__btn-text">{{step.name}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Swiper from 'swiper'
  import windowSizeMixin from '../../mixins/windowSizeMixin'

  export default {
    name: 'InteractionNavBar',
    mixins: [windowSizeMixin],
    data() {
      return {
        steps: [
          {
            id: 1,
            name: this.$tInteraction('The passport'),
            ico: 'ico-passport',
            key: 'passport',
          },
          {
            id: 2,
            name: this.$tInteraction('Insurance'),
            ico: 'ico-umbrella',
            key: 'insurance',
          },
          {
            id: 3,
            name: this.$tInteraction('Visa'),
            ico: 'ico-visa',
            key: 'visa',
          },
          {
            id: 4,
            name: this.$tInteraction('Invitation'),
            ico: 'ico-visa',
            key: 'invite',
          },
          {
            id: 4,
            name: this.$tInteraction('Ticket'),
            ico: 'ico-ticket',
            key: 'tickets',
          },
          {
            id: 5,
            name: this.$tInteraction('Contract'),
            ico: 'ico-contract',
            key: 'documents',
          }
        ],
        swiper: null,
        timer: null
      }
    },
    computed: {
      ...mapState('interaction', [
        'statuses'
      ]),
      getActiveIndex() {
        const statuses = this.statuses
        return this.steps.findIndex(item => statuses[item.key] === 'checked')
      },
      statusesKeys() {
        return  Object.keys(this.statuses)
      },
      stepsComputed() {
        return this.statusesKeys.map(status => {
          return this.steps.find(step => step.key === status)
        })
      }
    },
    methods: {
      createSwiper() {
        if (!this.$refs['nav-carousel']) return
        // debugger
        this.swiper = new Swiper(this.$refs['nav-carousel'], {
          wrapperClass: 'interaction-nav-bar__buttons',
          slideClass: 'interaction-nav-bar__buttons-item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          centerInsufficientSlides: true,
          allowTouchMove: false
        })

        this.swiper.slideTo(this.getActiveIndex)
      },
      checkMob() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.windowSizeMixin.width > 767) {
            if (this.swiper) {
              this.swiper.destroy();
              this.swiper = null
            }
          } else if (!this.swiper) {
            this.createSwiper()
          } else {
            this.swiper.slideTo(this.getActiveIndex)
          }
        }, 200)
      },
      getClass(key) {
        const status = this.statuses[key]
        return {
          '_done': status === 'checked',
          '_wait': status === 'pending',
          '_disabled': status === 'not_uploaded'
        }
      }
    },
    mounted() {
      this.checkMob()
      window.addEventListener('resize', this.checkMob)
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy()
      }
      window.removeEventListener('resize', this.checkMob)
    },
    watch: {
      statuses(to, from) {
        if (isSameStatuses(to, from)) return

        if (this.swiper) {
          this.swiper.destroy()
          this.swiper = null
        }

        this.checkMob()
      }
    }
  }

  function isSameStatuses(to, from) {
    if (to && !from || !to && from) {
      return false
    }

    if (!to) return true

    for (const key in to) {
      if (to[key] !== from[key]) return false
    }

    return true
  }
</script>

<style>

</style>
